export const ASSIGNMENT = 'ASSIGNMENT';
export const FILTER_CHANGE = 'FILTER_CHANGE';
export const THREAD_STATUS = 'THREAD_STATUS';
export const TICKET_ASSOCIATION = 'TICKET_ASSOCIATION';
export const HARD_DELETION = 'HARD_DELETION';
export const UNKNOWN = 'UNKNOWN';
export const INBOX_CHANGE = 'INBOX_CHANGE';
export const MULTIPLE = 'MULTIPLE';